import { Box, Button, Card, InputAdornment, CardContent, CardMedia, Chip, FormControl, Grid, InputLabel, MenuItem, Select, Skeleton, Stack, IconButton, Tooltip, Typography, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';
import StarIcon from '../../img/StarIcon.png';
import { useDispatch, useSelector } from 'react-redux';
import NoResults from '../../components/reusableComponents/NoResults';
import { useHistory } from 'react-router-dom';
import Pagination from '../../_helpers/reusablefunctions/Pagination';
import SkeletonCard from '../../_helpers/reusablefunctions/SkeletonCard';
import playlist from '../../img/default-image.png'
import TableComponent from '../../components/Tablecomponent';
import ApiService from '../../_services/ApiService';
import SnackbarContainer from '../Snackbar';
import { useParams } from 'react-router-dom';

export default function ArtistMusicList() {
    // Redux state
    const history = useHistory()
    const userData = useSelector((state) => state.userData.userData);
    const [songList, setSongList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState()
    const { songId } = useParams();

    // Define table columns
    const columnsSong = [
        {
            id: 'songPoster',
            label: 'Song Title',
            template: (row) => (
                <Box
                    onClick={() => openDetails(row)}
                    display="flex"
                    alignItems="center"
                    gap={2}>
                    <img
                        src={getImageUrl(row, 'table')}
                        alt="song thumbnail"
                        style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
                    />
                    <Tooltip title={row?.songTitle} placement="top" arrow>
                        <Typography
                            variant='body2'
                            className='text-truncate'
                            style={{ cursor: 'pointer' }}
                            onClick={() => openDetails(row)}
                        >
                            {row?.songTitle || '--'}
                        </Typography>
                    </Tooltip>
                </Box>
            ),
        },
        {
            id: 'artists',
            label: 'Artists',
            template: (row) => (
                <Box display="flex" alignItems="center" gap={2}>
                    <Tooltip title={row?.artists} placement="top" arrow>
                        <Typography
                            variant='body2'
                            className='text-truncate'
                            style={{ cursor: 'pointer' }}
                        >
                            {row?.artists || '--'}
                        </Typography>
                    </Tooltip>
                </Box>
            ),
        }, {
            id: 'genre',
            label: 'Genre',
            template: (row) => (
                <Typography variant="body2" className='text-truncate'>
                    {row?.genre?.genre || '--'}
                </Typography>
            ),
        },
        {
            id: 'mood',
            label: 'Mood',
            template: (row) => (
                <Typography variant="body2" className='text-truncate'>
                    {row?.mood?.mood || '--'}
                </Typography>
            ),
        },
        {
            id: 'language',
            label: 'Language',
            template: (row) => (
                <Typography variant="body2" className='text-truncate'>
                    {row?.language?.language || '--'}
                </Typography>
            ),
        },
        {
            id: 'rating',
            label: 'Rating',
            template: (row) => {
                return (
                    <Box className='d-flex align-items-center gap-2'>
                        <img src={StarIcon} alt='StarIcon' style={{ width: 16, height: 16 }} />
                        <Typography variant="body2">
                            {row?.song_rating ? `${row.song_rating.average_rating}/5 (${row.song_rating.rating_count} Rating)` : '0/5 (0 Rating)'}
                        </Typography>
                    </Box>
                );
            },
        },

    ];

    function songlistApi(url) {
        setLoader(true)
        setSongList([])
        ApiService.get('userSongList', { search: songId, limit: 10, offset: page }).then(res => {
            const response = res?.data || []
            setLoader(false)
            if (response) {
                setSongList(response?.results)
                setTotalCount(response?.total_count)
            }
        }).catch(function (error) {
            console.log(error);
            console.log(error.response);
        });
    }

    useEffect(() => {
        if (userData) {
            songlistApi()
        }
    }, [userData, page, rowsPerPage, songId]);


    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value);
        const newPage = Math.floor((page * rowsPerPage) / newRowsPerPage);
        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    // Fetch analytics data for the song
    async function fetchSongAnalytics(data) {
        let user = {
            uid: userData?.creator_auth,
            platform: 'web'
        };
        try {
            const response = await ApiService.post('songAnalytics', { user }, `${data?.id}/click?revoke=false`);
            if (response.status === 200 || response.status === 201) {
                // Handle the response data as needed
                console.log('Song Analytics:', response.data);
            }
        } catch (error) {
            console.error('Error fetching song analytics:', error);
        }
    }

    const openDetails = async (data) => {
        await fetchSongAnalytics(data);
        history.push(`/songdetail/${data.id}`, { musicData: data })
    }

    const getImageUrl = (data, value) => {

        if (data?.songPoster100x100 || data.songPoster300x300) {
            return value == 'card' ? data?.songPoster300x300 : data?.songPoster100x100
        }
        if (data?.songPoster_url) {
            return data?.songPoster_url;
        }
        if (data?.songPoster) {
            return `${process.env.REACT_APP_BASEURL_MEDIA}/media/${data.songPoster}`;
        }
        if (data?.cover_image) {
            return `${process.env.REACT_APP_SONGAPIURL_MEDIA}${data.cover_image}`
        }
        return playlist;
    };

    // Render card view
    const renderCardView = () => (
        <Grid container spacing={2}>
            {loader ?
                Array.from(new Array(8)).map((item, index) => (
                    <Grid key={index} item xs={12} sm={6} md={3} lg={3}>
                        <SkeletonCard />
                    </Grid>
                ))
                :
                loader === false && songList.length === 0 ? (
                    <NoResults message="No Result Found" />
                )
                    :
                    songList.map((data, index) => (
                        <Grid key={index} item xs={12} sm={6} md={3} lg={3}>
                            <Card>
                                <CardMedia
                                    sx={{
                                        aspectRatio: '1 / 1',
                                        width: '100%',
                                        objectFit: 'cover',
                                        cursor: 'pointer'
                                    }}
                                    image={getImageUrl(data, 'card')}
                                    title="song-thumbnail"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => openDetails(data)}
                                />
                                <CardContent sx={{ paddingBottom: '0px' }}>
                                    <Tooltip title={data.songTitle}
                                        placement="top"
                                        arrow>
                                        <Typography className='text-truncate'>
                                            {data?.songTitle || '--'}
                                        </Typography>
                                    </Tooltip>

                                    <Typography variant="body2" sx={{ color: 'text.secondary' }} component="div" className='d-flex align-items-center gap-2'>
                                        <img src={StarIcon} alt='StarIcon' />
                                        {data?.song_rating ? `${data.song_rating.average_rating}/5 (${data.song_rating.rating_count} Rating)` : '0/5 (0 Rating)'}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))
            }
            <Pagination
                totalCount={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Grid>
    );

    // Render table view
    const renderTableView = () => {
        if (loader) {
            return (
                <Paper>
                    <Box p={3}>
                        {Array.from(new Array(5)).map((_, index) => (
                            <Skeleton key={index} variant="rectangular" height={60} sx={{ mb: 1 }} />
                        ))}
                    </Box>
                </Paper>
            );
        }

        if (songList.length === 0) {
            return <NoResults message="No Result Found" />;
        }

        return (
            <Paper>
                <TableComponent
                    totalCount={totalCount}
                    setRowsPerPage={setRowsPerPage}
                    rowsPerPage={rowsPerPage}
                    setPage={setPage}
                    page={page}
                    columns={columnsSong}
                    data={songList}
                />
            </Paper>
        );
    };

    return (
        <Box className='container-fluid py-4 px-4 creator-playlist-panel'>
            <Box>
                <h2>Songs</h2>
            </Box>

            <Box className='my-4'>
                {renderTableView()}
            </Box>
            <SnackbarContainer />
        </Box>
    )
}